import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import CopyModel from './components/CopyModel';
import Edabc from './components/Edabc';
import NationalCopy from './components/NationalCopy';
import Cta from './components/Cta';

export default function Scale() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="千县万村 | 0#→1#→N# 全国数字商业网络"
        description="九畴云铺千县万村全国复制路线，从0#帝星到1#大庄科再到N#，以EDABC网络模型驱动县域规模化扩张。"
        keywords="千县万村,EDABC,全国复制,数字商业网络,县域经济"
        path="/scale"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '千县万村',
          description: '九畴云铺全国复制路线与数字商业网络',
        }}
      />
      <main>
        <Hero />
        <CopyModel />
        <Edabc />
        <NationalCopy />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}